import CheckBoxGroup from "./CheckBoxGroup.component";

export default CheckBoxGroup;
